/* unplugin-vue-components disabled */import script from "./Stepper.vue?vue&type=script&lang=ts&setup=true"
export * from "./Stepper.vue?vue&type=script&lang=ts&setup=true"

import "./Stepper.vue?vue&type=style&index=0&id=3ed844f2&lang=scss"

const __exports__ = script;

export default __exports__